var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9001 2.1L20.7991 3.515L22.2131 13.415L13.0211 22.607C12.8336 22.7945 12.5793 22.8998 12.3141 22.8998C12.0489 22.8998 11.7946 22.7945 11.6071 22.607L1.70709 12.707C1.51962 12.5195 1.41431 12.2652 1.41431 12C1.41431 11.7348 1.51962 11.4805 1.70709 11.293L10.9001 2.1ZM11.6071 4.222L3.82809 12L12.3141 20.485L20.0921 12.707L19.0321 5.282L11.6071 4.222ZM13.7271 10.586C13.3519 10.2107 13.1412 9.70178 13.1413 9.17115C13.1414 8.9084 13.1932 8.64824 13.2938 8.40552C13.3944 8.16279 13.5418 7.94225 13.7276 7.7565C13.9134 7.57074 14.134 7.42341 14.3768 7.3229C14.6195 7.2224 14.8797 7.17069 15.1425 7.17074C15.6731 7.17083 16.1819 7.38172 16.5571 7.757C16.9322 8.13228 17.143 8.64122 17.1429 9.17185C17.1428 9.70249 16.9319 10.2114 16.5566 10.5865C16.1813 10.9616 15.6724 11.1724 15.1417 11.1723C14.6111 11.1722 14.1022 10.9613 13.7271 10.586Z",
    fill: "#009FE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.46041023db8618b05c50abfb458ee6c6.svg";
export { ForwardRef as ReactComponent };